import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { BUSINESS, LOGO_URL } from "@/lib/api";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-primary text-primary-foreground">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <img
            src={LOGO_URL}
            alt="AeroAcres Drone Spraying"
            className="h-[250px] w-auto object-contain mb-4 -ml-3"
            loading="lazy"
          />
          <p className="text-sm text-primary-foreground/70 leading-relaxed">
            FAA Part 137 certified drone crop spraying for South Florida agriculture. Precision application that
            saves water, chemical and time.
          </p>
        </div>
        <div>
          <div className="font-display text-sm font-semibold uppercase tracking-widest mb-4 text-accent">Services</div>
          <ul className="space-y-2 text-sm text-primary-foreground/75">
            <li><Link to="/drone-pesticide-spraying-florida/" className="hover:text-accent">Pesticide Application</Link></li>
            <li><Link to="/herbicide-drone-application-miami/" className="hover:text-accent">Herbicide Spraying</Link></li>
            <li><Link to="/fungicide-drone-treatment-homestead/" className="hover:text-accent">Fungicide Treatment</Link></li>
            <li><Link to="/drone-spraying-avocado-groves/" className="hover:text-accent">Avocado Grove Spraying</Link></li>
            <li><Link to="/citrus-drone-spraying-florida/" className="hover:text-accent">Citrus Spraying</Link></li>
            <li><Link to="/nursery-drone-application-florida/" className="hover:text-accent">Nursery Application</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-display text-sm font-semibold uppercase tracking-widest mb-4 text-accent">Service Area</div>
          <ul className="space-y-2 text-sm text-primary-foreground/75">
            <li><Link to="/homestead-drone-spraying/" className="hover:text-accent">Homestead, FL</Link></li>
            <li><Link to="/florida-city-crop-spraying/" className="hover:text-accent">Florida City</Link></li>
            <li><Link to="/drone-crop-spraying-miami-dade/" className="hover:text-accent">Miami-Dade County</Link></li>
            <li><Link to="/agricultural-drone-spraying-redland-fl/" className="hover:text-accent">Redland Agricultural Area</Link></li>
            <li><Link to="/miami-drone-agriculture/" className="hover:text-accent">South Miami</Link></li>
            <li><Link to="/broward-county-drone-farming/" className="hover:text-accent">Broward County</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-display text-sm font-semibold uppercase tracking-widest mb-4 text-accent">Contact</div>
          <ul className="space-y-3 text-sm text-primary-foreground/85">
            <li className="flex items-start gap-2.5"><Phone className="h-4 w-4 mt-0.5 text-accent shrink-0" /><a href={`tel:${BUSINESS.phoneRaw}`} data-conversion="phone-call" className="track-phone-click hover:text-accent">{BUSINESS.phone}</a></li>
            <li className="flex items-start gap-2.5"><Mail className="h-4 w-4 mt-0.5 text-accent shrink-0" /><a href={`mailto:${BUSINESS.email}`} className="hover:text-accent">{BUSINESS.email}</a></li>
            <li className="flex items-start gap-2.5"><MapPin className="h-4 w-4 mt-0.5 text-accent shrink-0" /><span>{BUSINESS.address}</span></li>
            <li className="flex items-start gap-2.5"><Clock className="h-4 w-4 mt-0.5 text-accent shrink-0" /><span>{BUSINESS.hours}</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-primary-foreground/10">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-primary-foreground/55">
          <div>© {new Date().getFullYear()} AeroAcres Drone Spraying · FAA Part 137 Certified · Homestead, FL</div>
          <div className="flex items-center gap-4">
            <Link to="/blog/" className="hover:text-accent">Blog</Link>
            <Link to="/drone-spraying-florida-guide/" className="hover:text-accent">Florida Guide</Link>
            <Link to="/login" data-testid="footer-admin-link" className="hover:text-accent">Admin</Link>
            <a href="#contact" className="hover:text-accent">Free Quote</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
